// extracted by mini-css-extract-plugin
export var container = "_gb-1";
export var editor = "_gb-2";
export var resizable = "_gb-3";
export var wrapper = "_gb-0";